<template>
  <section class="section alt">
    <div class="container split">
      <div>
        <h1>Particuliers</h1>
        <p class="lead">
          Des solutions claires pour protéger votre foyer, votre santé et vos projets personnels.
        </p>
        <ul class="list">
          <li>Habitation, responsabilité civile et protection juridique</li>
          <li>Auto, deux-roues et mobilité douce</li>
          <li>Santé, prévoyance et dépendance</li>
          <li>Assurance emprunteur et préparation retraite</li>
          <li>Protection du patrimoine familial</li>
        </ul>
      </div>
      <div class="panel">
        <h2>Votre quotidien, notre priorité</h2>
        <p>Des garanties lisibles et un interlocuteur dédié à chaque étape.</p>
        <router-link class="button primary" to="/contact">Demander un diagnostic</router-link>
      </div>
    </div>
  </section>
</template>
